import { Button, Flex, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { CARS_PAGE_SIZE_ALL } from '../../utils/vinExtraction';
import { failedRowBackground, mutedSmallStyle } from './vinExtractionStyles';

/** The cars table, "Showing N of M" and View all (which switches to pages of 100). */
const BatchCarsTable = ({ data, loading, query, setQuery, columns }) => {
    const { t } = useTranslation('vinExtraction');
    const { items, total } = data;
    const viewAll = query.pageSize === CARS_PAGE_SIZE_ALL;

    return (
        <>
            <Table
                size="small"
                rowKey="carId"
                columns={columns}
                dataSource={items}
                loading={loading}
                scroll={{ x: 'max-content' }}
                onRow={car => (car.status === 'failed' ? { style: { backgroundColor: failedRowBackground } } : {})}
                pagination={
                    viewAll && {
                        current: query.page,
                        pageSize: CARS_PAGE_SIZE_ALL,
                        total,
                        showSizeChanger: false,
                        onChange: page => setQuery(prev => ({ ...prev, page })),
                    }
                }
            />
            <Flex justify="space-between" align="center" gap={spacing[2]} wrap="wrap">
                <span style={mutedSmallStyle}>{t('cars.showing', { shown: items.length, total })}</span>
                {!viewAll && total > items.length && (
                    <Button
                        type="link"
                        size="small"
                        onClick={() => setQuery(prev => ({ ...prev, page: 1, pageSize: CARS_PAGE_SIZE_ALL }))}
                    >
                        {t('cars.viewAll')}
                    </Button>
                )}
            </Flex>
        </>
    );
};

export default BatchCarsTable;
